import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Login } from './pages/Login';
import Dashboard from './pages/Dashboard';
import PrivateRoute from './components/PrivateRoute';
import Register from './pages/Register';
import Profile from './pages/Profile';
import BottomNav, { ALTURA_BOTTOM_NAV } from './components/BottomNav';
import SidebarNav, { LARGURA_SIDEBAR } from './components/SidebarNav';
import Planejamento from './pages/Planejamento';
import Lancamentos from './pages/Lancamentos';
import Categorias from './pages/Categorias';
import Cartoes from './pages/Cartoes';
import FaturasCartao from './pages/FaturasCartao';
import Bancos from './pages/Bancos';
import ExtratoBanco from './pages/ExtratoBanco';
import ContasPagar from './pages/ContasPagar';
import { Box } from '@chakra-ui/react';

const PageWithNav = ({ children }: { children: React.ReactNode }) => (
  <>
    <SidebarNav />
    <Box ml={{ base: 0, md: LARGURA_SIDEBAR }} pb={{ base: `calc(${ALTURA_BOTTOM_NAV} + 16px + env(safe-area-inset-bottom))`, md: 0 }}>
      {children}
      <BottomNav />
    </Box>
  </>
);

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={
          <PrivateRoute>
            <PageWithNav>
              <Dashboard />
            </PageWithNav>
          </PrivateRoute>
        } />
        <Route path="/planejamento" element={
          <PrivateRoute>
            <PageWithNav>
              <Planejamento />
            </PageWithNav>
          </PrivateRoute>
        } />
        <Route path="/contas" element={
          <PrivateRoute>
            <PageWithNav>
              <ContasPagar />
            </PageWithNav>
          </PrivateRoute>
        } />
        <Route path="/lancamentos" element={
          <PrivateRoute>
            <PageWithNav>
              <Lancamentos />
            </PageWithNav>
          </PrivateRoute>
        } />
        <Route path="/profile" element={
          <PrivateRoute>
            <PageWithNav>
              <Profile />
            </PageWithNav>
          </PrivateRoute>
        } />
        <Route path="/categorias" element={
          <PrivateRoute>
            <PageWithNav>
              <Categorias />
            </PageWithNav>
          </PrivateRoute>
        } />
        <Route path="/cartoes" element={
          <PrivateRoute>
            <PageWithNav>
              <Cartoes />
            </PageWithNav>
          </PrivateRoute>
        } />
        <Route path="/faturas-cartao" element={
          <PrivateRoute>
            <PageWithNav>
              <FaturasCartao />
            </PageWithNav>
          </PrivateRoute>
        } />
        <Route path="/bancos" element={
          <PrivateRoute>
            <PageWithNav>
              <Bancos />
            </PageWithNav>
          </PrivateRoute>
        } />
        <Route path="/extrato-banco" element={
          <PrivateRoute>
            <PageWithNav>
              <ExtratoBanco />
            </PageWithNav>
          </PrivateRoute>
        } />
        {/* Outras rotas protegidas podem ser adicionadas aqui futuramente */}
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );
}

export default App;
